import React from "react";
import { ArrowRight, Thermometer, Activity, ShieldCheck, Cpu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExcelenciaEmEngenhariaTermica() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="excelência-em-engenharia-térmica" className="dark bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden" ref={ref}>
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/doctorice_hero_industrial_chiller.png)] bg-cover bg-center opacity-40 mix-blend-overlay" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-background/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
      </div>

      {}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-[0.03]" aria-hidden="true">
        <svg className="w-full h-full" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid-pattern" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern)" />
        </svg>
      </div>

      {}
      <div className="absolute right-0 top-1/4 w-1/3 h-1/2 opacity-10 pointer-events-none hidden lg:block">
        <svg viewBox="0 0 400 400" className="w-full h-full stroke-primary fill-none stroke-[2]">
          <path d="M0,200 Q100,200 150,150 T300,150 T400,200" className="animate-[dash_10s_linear_infinite]" strokeDasharray="10,10" />
          <path d="M0,250 Q120,250 180,300 T350,300 T400,250" className="animate-[dash_15s_linear_infinite]" strokeDasharray="5,5" />
        </svg>
      </div>

      <div className="container relative z-10 mx-auto px-4 py-20 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {}
          <div className={`lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            
            {}
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 w-fit">
              <Activity className="w-4 h-4 text-primary" />
              <span className="text-xs font-medium tracking-wider uppercase text-primary-foreground/80">
                Engenharia Térmica de Alta Precisão
              </span>
            </div>

            {}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1]">
              Engenharia térmica e controle de temperatura para <span className="text-primary">aplicações críticas</span>.
            </h1>

            {}
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
              Projetos, equipamentos e serviços com confiabilidade para ambientes médico-hospitalares, salas limpas, telecom/datacenter e processos industriais.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-4 mt-2">
              <Button asChild size="lg" className="text-base h-12 px-8 shadow-lg shadow-primary/20">
                <Link to="/ContactPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground rounded-md has-[>svg]:px-4 text-base h-12 px-8 shadow-lg shadow-primary/20 !bg-[hsl(175,77%,26%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">
                  Solicitar proposta
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="text-base h-12 px-8 border-primary/20 hover:bg-primary/5">
                <Link to="/ContactPage">
                  Falar com engenharia
                </Link>
              </Button>
            </div>

            {}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-8 pt-8 border-t border-border/50">
              {[{
              icon: ShieldCheck,
              label: "Confiabilidade Operacional",
              value: "Alta Performance"
            }, {
              icon: Thermometer,
              label: "Controle Preciso",
              value: "Temp. & Umidade"
            }, {
              icon: Cpu,
              label: "Tecnologia",
              value: "Engenharia Aplicada"
            }].map((item, i) => <div key={i} data-index={i} className="flex items-start gap-3">
                  <div className="p-2 rounded-lg bg-secondary/20 text-primary mt-1">
                    <item.icon className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="font-semibold text-foreground">{item.value}</p>
                    <p className="text-sm text-muted-foreground">{item.label}</p>
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div className="lg:col-span-5 hidden lg:block relative h-full min-h-[400px]">
             {}
             <div className={`absolute top-1/2 right-0 -translate-y-1/2 bg-card/5 backdrop-blur-sm border border-white/10 p-6 rounded-xl max-w-xs transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
                <div className="flex items-center gap-4 mb-4">
                   <div className="h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center">
                      <Activity className="w-5 h-5 text-primary" />
                   </div>
                   <div>
                      <div className="text-sm font-medium text-muted-foreground">Status do Sistema</div>
                      <div className="text-lg font-bold text-foreground">Operacional</div>
                   </div>
                </div>
                <div className="space-y-2">
                   <div className="h-1.5 w-full bg-muted/20 rounded-full overflow-hidden">
                      <div className="h-full bg-primary w-[92%] rounded-full" />
                   </div>
                   <div className="flex justify-between text-xs text-muted-foreground">
                      <span>Eficiência</span>
                      <span>98%</span>
                   </div>
                </div>
             </div>
          </div>
        </div>
      </div>
    </section>;
}